/* © Kwazar. All rights reserved. Proprietary theme code — copying, redistribution or resale is prohibited. */
class MxAnnouncement extends HTMLElement {
  connectedCallback() {
    if (this.dataset.mode === 'marquee') return;
    this.items = [...this.querySelectorAll('.mx-announcement__item')];
    if (this.items.length < 2) return;
    this.index = 0;
    this.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', () => { this.go(this.index + Number(b.dataset.dir)); this.restart(); }));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.restart());
    this.addEventListener('shopify:block:select', (e) => { this.stop(); this.go(this.items.indexOf(e.target)); });
    this.restart();
  }
  disconnectedCallback() { this.stop(); }
  go(i) {
    this.items[this.index].classList.remove('is-active');
    this.index = (i + this.items.length) % this.items.length;
    this.items[this.index].classList.add('is-active');
  }
  stop() { clearInterval(this.timer); }
  restart() {
    this.stop();
    if (this.dataset.mode === 'inline' && matchMedia('(min-width: 750px)').matches) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.interval) || 5000);
  }
}
if (!customElements.get('mx-announcement')) customElements.define('mx-announcement', MxAnnouncement);
